var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductSearchsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    transform: "rotate(-180 10.5 10.5)",
    fill: "white",
    stroke: "#C40F11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8968_2503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.16667C7.25 9.54969 7.32544 9.92896 7.47202 10.2828C7.61859 10.6367 7.83343 10.9582 8.10427 11.2291C8.37511 11.4999 8.69664 11.7147 9.05051 11.8613C9.40437 12.0079 9.78364 12.0833 10.1667 12.0833C10.5497 12.0833 10.929 12.0079 11.2828 11.8613C11.6367 11.7147 11.9582 11.4999 12.2291 11.2291C12.4999 10.9582 12.7147 10.6367 12.8613 10.2828C13.0079 9.92896 13.0833 9.54969 13.0833 9.16667C13.0833 8.78364 13.0079 8.40437 12.8613 8.05051C12.7147 7.69664 12.4999 7.37511 12.2291 7.10427C11.9582 6.83343 11.6367 6.61859 11.2828 6.47202C10.929 6.32544 10.5497 6.25 10.1667 6.25C9.78364 6.25 9.40437 6.32544 9.05051 6.47202C8.69664 6.61859 8.37511 6.83343 8.10427 7.10427C7.83343 7.37511 7.61859 7.69664 7.47202 8.05051C7.32544 8.40437 7.25 8.78364 7.25 9.16667Z",
    stroke: "#C40F11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.75L12.25 11.25",
    stroke: "#C40F11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8968_2503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSearchsvg);
export default __webpack_public_path__ + "static/media/product-search.svg.1315819bac6b42deec0668120d98fa9e.svg";
export { ForwardRef as ReactComponent };